import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { rsvpAnswerTypes } from '@bridebook/web/lib/rsvp/constants/events';

export const useGetPlaceholderAnswerTypeOptions = (): Array<{
  value: (typeof rsvpAnswerTypes)[number];
  label: string;
}> => {
  const { t } = useTranslation('weddingWebsite');

  return useMemo(
    () => [
      {
        value: 'boolean',
        label: t('rsvp.placeholder.form.type.boolean'),
      },
      {
        value: 'list',
        label: t('rsvp.placeholder.form.type.list'),
      },
      {
        value: 'string',
        label: t('rsvp.placeholder.form.type.string'),
      },
      // not supported in RSVP v1
      // { value: 'conditional', label: t('rsvp.placeholder.form.type.conditional', 'Conditional') },
    ],
    [t],
  );
};
